module.exports = __webpack_public_path__ + "static/media/041-tooth extraction.216b9340.svg";